import { useCallback, useEffect, useState } from 'react';
export const useCarouselWithThumbs = (initialIndex = 0) => {
    const [selectedIndex, setSelectedIndex] = useState(initialIndex);
    const [mainApi, setMainApi] = useState(null);
    const [thumbApi, setThumbApi] = useState(null);
    const onThumbClick = useCallback((index) => {
        if (!mainApi || !thumbApi) {
            return;
        }
        mainApi.scrollTo(index);
    }, [mainApi, thumbApi]);
    const onSelect = useCallback(() => {
        if (!mainApi || !thumbApi) {
            return;
        }
        setSelectedIndex(mainApi.selectedScrollSnap());
        thumbApi.scrollTo(mainApi.selectedScrollSnap());
    }, [mainApi, thumbApi, setSelectedIndex]);
    useEffect(() => {
        if (!mainApi) {
            return;
        }
        onSelect();
        mainApi.on('select', onSelect).on('reInit', onSelect);
    }, [mainApi, onSelect]);
    return {
        selectedIndex,
        setMainApi,
        setThumbApi,
        onThumbClick,
    };
};
